/**
 * ライブ航跡の「巻き戻り」対策。
 *
 * 送信バッファは HTTP 200 が返ったときだけクリアする作り（原典GVConnector
 * 互換、gv-core の RelayClient）になっている。そのため、サーバーには実際に
 * 届いて処理されたのにレスポンスだけ届かなかった場合（移動中の4Gの瞬断・
 * 基地局ハンドオーバーなどで起こりうる）、クライアントは失敗と判断して
 * 同じ行を次回に再送してしまう。サーバー・ブリッジのどちらも受信データを
 * 重複除去せずそのまま追記するため、届いた航跡に同じ点が時系列を無視して
 * 混ざり込み、地図上で航跡が一瞬過去へ巻き戻って見える（実機の移動テストで
 * 確認済み）。
 *
 * 送信プロトコル自体（原典互換性）には手を入れず、「直前に採用した点より
 * 新しい時刻の点だけを残す」だけで表示側から吸収する。
 *
 * ★ この「直前より新しい時刻だけ採用する」方式自体にも弱点がある
 *   （2026-09-13、TVのバージョン違いで実際に起きた「航跡が20〜40分飛ぶ」
 *   不具合の調査より）。もし一度でも実際より先の時刻を持つ点を「直前に
 *   採用した点」として基準にしてしまうと、以後届く正しい時刻の点が
 *   すべて「基準より古い」と判定されて捨てられ続けてしまう。
 *   `isPlausibleLiveFixTime`で、そもそも未来方向にありえない時刻の点を
 *   「新しい」と判定しない（＝基準として採用しない）ようにして防ぐ。
 */

import { isPlausibleLiveFixTime, type FixSample } from '@gv4d/core';

/** 追加してよいか（直前に採用した点より新しい時刻か、かつ未来方向にもっともらしいか）を判定する */
export function isNewerFix(last: FixSample | undefined, fix: FixSample, nowMs = Date.now()): boolean {
  if (!isPlausibleLiveFixTime(fix.t, nowMs)) return false;
  return !last || fix.t > last.t;
}

/** 配列全体から、時刻が単調に増えるものだけを残す（サーバーから届く初期snapshot用） */
export function dropOutOfOrderFixes(fixes: FixSample[]): FixSample[] {
  const kept: FixSample[] = [];
  for (const fix of fixes) {
    if (isNewerFix(kept[kept.length - 1], fix)) kept.push(fix);
  }
  return kept;
}
